export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "What areas does EMD Cleaning Service serve?",
    a: "We're headquartered at 500 East E Street in Ontario, California and serve the Inland Empire and surrounding Southern California communities — including Chino, Chino Hills, Pomona, West Covina, Montclair, Claremont, Upland, Rancho Cucamonga, Fontana, San Bernardino, Jurupa Valley, East Valley, Corona, and Riverside.",
  },
  {
    q: "Are you bonded and insured?",
    a: "Yes. Every cleaner on our team is background-checked, bonded, and fully insured. Your home and business are completely protected when you book with us.",
  },
  {
    q: "Do you provide cleaning supplies and equipment?",
    a: "Yes — we bring everything we need: safe products for your home, microfiber cloths, mops, vacuums, and professional-grade equipment for post-construction and heavy-duty jobs. You don't need to lift a finger.",
  },
  {
    q: "How much does a cleaning cost?",
    a: "Pricing depends on the size of your space, the type of cleaning (recurring maintenance vs. a one-time deep clean), and any add-ons like junk removal. We provide free, no-pressure written estimates — just call (909) 443-9863 or email emdlimpieza@gmail.com and we'll build you a custom quote.",
  },
  {
    q: "Do you offer discounts for repeat customers?",
    a: "Yes. Returning customers receive 20% off their cleaning. Whether you book weekly, bi-weekly, or monthly, that discount applies every time you come back to us.",
  },
  {
    q: "What hours are you open?",
    a: "We're open Monday through Saturday, 8:00 AM to 6:00 PM. We are closed on Sundays. If you need service outside those hours, let us know when you request your estimate and we'll do our best to accommodate your schedule.",
  },
  {
    q: "What's included in a deep clean vs. a regular clean?",
    a: "A regular clean covers ongoing upkeep — kitchens, bathrooms, floors, dusting, and high-touch surfaces. A deep clean adds the detail work: baseboards, inside appliances, grout, blinds, ceiling fans, door frames, and built-up buildup in corners that routine visits don't reach.",
  },
  {
    q: "Do you handle post-construction cleanup and junk removal?",
    a: "We do. Post-construction cleaning covers drywall dust, paint splatter, adhesive residue, window film, and fine debris left behind after a remodel or new build. We also offer junk removal to haul away unwanted furniture, appliances, boxes, and construction debris so your space is genuinely move-in ready.",
  },
  {
    q: "Can you clean just one room or a specific area?",
    a: "Absolutely — that's our specific area cleaning service. If you only need the kitchen, the garage, a single bathroom, or one problem area handled, we'll scope and quote exactly that. There's no requirement to book the whole property.",
  },
];
